import React from 'react';
import { Grid } from 'semantic-ui-react';
import './CustomerInformationDisplay.css';
var defaultProps = {};
function CustomerInformationDisplay(_ref) {
  var email = _ref.email,
    phoneNumber = _ref.phoneNumber,
    firstName = _ref.firstName,
    lastName = _ref.lastName;
  return /*#__PURE__*/React.createElement("div", {
    className: "customer-information-display-container"
  }, /*#__PURE__*/React.createElement(Grid, {
    columns: 2,
    stackable: true
  }, /*#__PURE__*/React.createElement(Grid.Column, null, /*#__PURE__*/React.createElement("small", null, "First Name"), /*#__PURE__*/React.createElement("p", null, firstName)), /*#__PURE__*/React.createElement(Grid.Column, null, /*#__PURE__*/React.createElement("small", null, "Last Name"), /*#__PURE__*/React.createElement("p", null, lastName)), /*#__PURE__*/React.createElement(Grid.Column, null, /*#__PURE__*/React.createElement("small", null, "Email Address"), /*#__PURE__*/React.createElement("p", null, email)), /*#__PURE__*/React.createElement(Grid.Column, null, /*#__PURE__*/React.createElement("small", null, "Phone Number"), /*#__PURE__*/React.createElement("p", null, phoneNumber))));
}
CustomerInformationDisplay.defaultProps = defaultProps;
export default CustomerInformationDisplay;